function prediction_ai_rain(){
    // 
    let timeParameter = {
            current: {
                value: get_now_time_utc_value() - (8 * 3600000),
                string: UTCtoString_v2(get_now_time_utc_value() - (8 * 3600000))
            },
            past: {
                value: get_now_time_utc_value() - (8 * 3600000) - (24 * 3600000 * 7),
                string: UTCtoString_v2(get_now_time_utc_value() - (8 * 3600000) - (24 * 3600000 * 7))
            }
        }
    // 
    $("#map_clear").click()
	$("#prediction_ai_rain").html(`
        <div class="pr-2" style="height: calc( 100vh - 115px );">  
            <h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>降雨預測模組功能說明</h5>
            <h6 class="text-justify mt-1">以深度學習網路為運算基礎，考量氣象環境、天氣型態事件與地形等要素，整合異質資料強化估計成果。預測模型包含「雷達迴波預測模型」與「即時雨量估計模型」，方便日後模型進行驗證與優化。</h6>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <span class="input-group-text">預報時段</span>
                </div>
                <input type="text" class="form-control region-rain-prediction-report-date-picker" target="start_time" value="${timeParameter.past.string.slice(0, 4)}-${timeParameter.past.string.slice(5, 7)}-${timeParameter.past.string.slice(8, 10)}">
                <input type="text" class="form-control region-rain-prediction-report-date-picker" target="end_time" value="${timeParameter.current.string.slice(0, 4)}-${timeParameter.current.string.slice(5, 7)}-${timeParameter.current.string.slice(8, 10)}">
            </div>
            <div class="input-group mb-2"> 
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預報選擇</span> 
                </div> 
                <select class="form-control" id="region-rain-prediction-report-selector"></select>
            </div>
            <hr>
            <h5 class="font-weight-bold">
                <i class="fas fa-chart-bar mr-2"></i>行政區村里示警統計
                <button type="button" class="float-right btn btn-success btn-sm mt-1 pt-0 pb-0" id="region-rain-prediction-report-download">表單下載</button>
            </h5>
            <div id="region-rain-prediction-town-content"></div>
            <hr>
            <h5 class="font-weight-bold"><i class="fas fa-chess-board mr-2"></i>降雨預測網格檢視</h5>
            <div class="input-group mb-2">
                <div class="input-group-prepend"> 
                    <span class="input-group-text">顯示</span> 
                </div> 
                <select class="form-control region-rain-prediction-input" id="region-rain-prediction-layer-control"> 
                    <option value="open">開啟</option>
                    <option value="close" selected>關閉</option>
                </select>
                <div class="input-group-prepend"> 
                    <span class="input-group-text">類型</span> 
                </div> 
                <select class="form-control region-rain-prediction-input" id="region-rain-prediction-type-selector"> 
                    <option value="10m" selected>10分鐘累積雨量</option>
                    <option value="1hr">1小時累積雨量</option>
                    <option value="3hr">3小時累積雨量</option>
                </select>
            </div>
            <div class="input-group mb-2">
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預測時間檢視</span> 
                </div> 
                <select class="form-control region-rain-prediction-input" id="region-rain-prediction-time-selector"></select>
                <div class="input-group-append d-none">
                    <button class="btn btn-primary btn-sm region-rain-prediction-input" type="button" id="region-rain-prediction-layer-download">下載</button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-primary btn-sm region-rain-prediction-input" type="button" id="region-rain-prediction-layer-play">播放</button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-danger btn-sm" type="button" id="region-rain-prediction-layer-stop">停止</button>
                </div>
            </div>
            <div class="input-group mb-2 pb-4">
                <div class="input-group-prepend"> 
                    <span class="input-group-text">播放間隔秒數</span> 
                </div> 
                <select class="form-control region-rain-prediction-input" id="region-rain-prediction-recycle-time-selector">
                    <option value="1000">1秒</option>
                    <option value="2000">2秒</option>
                    <option value="3000">3秒</option>
                    <option value="4000">4秒</option>
                    <option value="5000">5秒</option>
                </select>
            </div>
        </div>`
    )
    // 日期選單
	$('.region-rain-prediction-report-date-picker').datepicker({
		format: 'yyyy-mm-dd',
		orientation: 'bottom'
	})
    $('.region-rain-prediction-report-date-picker').change(function(){
        let parameter = {},
            ai_rainList = {
                html: ""
            }
        $('.region-rain-prediction-report-date-picker').each(function(){
            parameter[$(this).attr('target')] = $(this).val()
        })
        if (Number(parameter["end_time"].replaceAll("-", "")) >= Number(parameter["start_time"].replaceAll("-", ""))) {
            ai_rainList.data = ajax_call(publicPath + "/napi/simulate/airain/" + parameter["start_time"].replaceAll("-", "") + "_0000/" + parameter["end_time"].replaceAll("-", "") + "_2350")
            ai_rainList.data.forEach(el => {
                let optionBgColor = ""
                if (el.red > 0 || el.orange > 0 || el.yellow > 0) {
                    optionBgColor = 'style="background-color: red;"'
                }
                ai_rainList.html += `<option ${optionBgColor} value="${el.time}">${timeConverter(el.time.replace("_", ""))} (${String(el.red)}紅、${String(el.orange)}橘、${String(el.yellow)}黃)</option>`
            })
            $("#region-rain-prediction-report-selector").html(ai_rainList.html).trigger("change")
        } else {
            toast_open("預報起訖時間輸入有誤！")
        }
    }).trigger("change")
    // 
	if ($("#legend_tag_降雨網格").length == 0) {
		$("#legend_div_container").append('<div class="mb-1 legend_text" id="legend_tag_降雨網格"> 降雨網格<br> <img src="legend/qpe_legend.png" width="100%"> </div><div class="mb-1 legend_text" id="legend_tag_區域降雨示警等級"> 區域降雨示警等級<br> <img src="legend/airain_alert_level.png" width="100%"> </div>');
	}
    // 
	let coorArray,
		typeMapping = {
			'10m': {
				name: '10分鐘累積雨量',
				alertArray: [10, 20, 30, 2],
                unit: "mm",
                note: ""
			},
			'1hr': {
				name: '1小時累積雨量',
				alertArray: [30, 40, 50, 60, 70, 80, 90, 100, 2],
                unit: "mm",
                note: ""
			},
			'3hr': {
				name: '3小時累積雨量',
				alertArray: [100, 110, 120, 130, 140, 150, 160, 170, 170, 180, 200, 2],
                unit: "mm",
                note: ""
			}
		},
		rawPredictData,
		townData = overlay_dataset["Basic_map"],
		nowTypeTargetAlertReport

    $("#region-rain-prediction-layer-control").change(function(){
        if ($(this).val() === "close") {
            inputDisabledControl(true)
            $(this).attr('disabled', false)
        } else {
            inputDisabledControl(false)
        }
        $("#region-rain-prediction-time-selector").trigger("change")
    }).trigger("change")

    $("#region-rain-prediction-report-selector").change(function(){
        coorArray = { 
            rain: { data: [] },
            radar: { data: [] }
        }
        let thisReportTime = $(this).val()
        if (raw_data["區域降雨預報"] && (raw_data["區域降雨預報"]["time"] === thisReportTime)) {
            rawPredictData = raw_data["區域降雨預報"]
        } else {
            let thisReportData = ajax_call(publicPath + "/napi/simulate/airain/" + thisReportTime)
            rawPredictData = {
                rain: thisReportData.data,
                time: thisReportTime,
                alert: thisReportData.village
            }
            raw_data["區域降雨預報"] = rawPredictData
        }
        Object.keys(rawPredictData).forEach(eachKey => {
            if (eachKey === "rain") {
                rawPredictData[eachKey].forEach((el, index) => {
                    var startCoor = el.upper_left_pixel_center_coord.replace(" ", "").split(',')
                    if (index === 0) {
                        coorArray[eachKey].resolution = el.resolution
                        for (let heightIndex = 0; heightIndex < el.height; heightIndex++) {
                            for (let widthIndex = 0; widthIndex < el.width; widthIndex++) {
                                coorArray[eachKey].data.push([Number(startCoor[0]) + (coorArray[eachKey].resolution * widthIndex), Number(startCoor[1]) - (coorArray[eachKey].resolution * heightIndex)])
                            }
                        }
                    }
                    el.predictionArray = []
                    el.prediction.forEach(eachRainValue => {
                        el.predictionArray.push(rain_value_processing(Number(eachRainValue)))
                    })
                })
            }
        })
		initialContent({
			value: $("#region-rain-prediction-type-selector").val(),
			action: "initial"
		})
        villageAlertRender({
            timeString: timeConverter(rawPredictData.rain[0].predict_time.replace("_", "")) + "起未來3小時內"
        })
    }).trigger("change")

	function initialContent(option){
		var target = option.value,
            typeKey = "rain"
        if (target === "dbz") {
            typeKey = "radar"
        }
		regionRainPredictionTypeChange(target)
		nowTypeTargetAlertReport = regionAlertRender()
	}

	$("#region-rain-prediction-type-selector").change(function(e){
		var target = $(this).val()
		initialContent({
			value: target,
			action: "initial"
		})
	})

	$("#region-rain-prediction-time-selector").change(function(){
		var target = {
				timeIndex: $(this).val(),
				renderType: $("#region-rain-prediction-type-selector").val()
			},
            rasterLayerStyle = rainRasterStyle,
            typeKey = "rain",
			geoJson = plotRainRasterGeoJson(parseInt(target.timeIndex), target.renderType),
			nowPredTime = timeConverter(rawPredictData[typeKey][Number(target.timeIndex)].predict_time.replace('_', ''))
		if (overlay_dataset["region_radar_prediction_layer"]) {
			map.removeLayer(overlay_dataset["region_radar_prediction_layer"])
		}
        if ($("#region-rain-prediction-layer-control").val() === "open") {
            overlay_dataset["region_radar_prediction_layer"] = L.geoJSON(geoJson, {
                style: rasterLayerStyle,
                interactive: false
            }).addTo(map)
        }
        $("#region-rain-prediction-layer-download").off().click(function(){
            downloadObjectAsJson(geoJson, typeMapping[target.renderType].name + "_" + nowPredTime)
        })
	})

	$("#region-rain-prediction-layer-play").click(function(){
		var nowValue = $("#region-rain-prediction-time-selector").val(),
			nowIndex = $('#region-rain-prediction-time-selector option[value="' + nowValue + '"]').index(),
			totalIndex = Number($("#region-rain-prediction-time-selector option").length - 1),
			step = 0,
			intervalObject = {},
			cyclePlaySec = Number($('#region-rain-prediction-recycle-time-selector').val())
		inputDisabledControl(true)
		$("#region-rain-prediction-time-selector").attr('disabled', true)
		for (var j = nowIndex; j <= totalIndex; j++) {
			(function(index) {
				intervalObject[j] = setTimeout(function(){
					$("#region-rain-prediction-time-selector").val($("#region-rain-prediction-time-selector option").eq(index).val()).trigger('change')
					if (index === totalIndex) {
						$("#region-rain-prediction-layer-stop").click()
					}
				}, cyclePlaySec * step)
				step = step + 1
			})(j);
		}
		$("#region-rain-prediction-layer-stop").click(function(){
			inputDisabledControl(false)
			for(var j = nowIndex; j <= totalIndex; j++) {
				clearTimeout(intervalObject[j]);
			}
		})
	})

	function plotRainRasterGeoJson(timeIndex, renderType){
		var geoJson = turf.featureCollection([]),
            typeKey = "rain"
        if (renderType === "dbz") {
            typeKey = "radar"
        }
        coorArray[typeKey].data.forEach((el, rasterIndex) => {
			var value = 0
			if (renderType === '10m' || renderType === 'dbz') {
                try {
                    value = rawPredictData[typeKey][timeIndex].predictionArray[rasterIndex]    
                } catch {}
			}
			if (renderType === '1hr') {
				for (let index = (timeIndex-5); index <= timeIndex; index++) {
					value += rawPredictData[typeKey][index].predictionArray[rasterIndex]
				}
			}
			if (renderType === '3hr') {
				for (let index = 0; index <= timeIndex; index++) {
					value += rawPredictData[typeKey][index].predictionArray[rasterIndex]
				}
			}
			// if (value > 0) {
            if (value == '-') {
                value = 0
            }
            geoJson.features.push(
                turf.polygon([[
                    [el[0] - (coorArray[typeKey].resolution * 0.5), el[1] - (coorArray[typeKey].resolution * 0.5)], 
                    [el[0] + (coorArray[typeKey].resolution * 0.5), el[1] - (coorArray[typeKey].resolution * 0.5)], 
                    [el[0] + (coorArray[typeKey].resolution * 0.5), el[1] + (coorArray[typeKey].resolution * 0.5)], 
                    [el[0] - (coorArray[typeKey].resolution * 0.5), el[1] + (coorArray[typeKey].resolution * 0.5)], 
                    [el[0] - (coorArray[typeKey].resolution * 0.5), el[1] - (coorArray[typeKey].resolution * 0.5)]]
                ], {
                    value: value
                })
            )
			// }
		})
		return geoJson
	}

	function regionRainPredictionTypeChange(type){
		var html = '',
            typeKey = "rain"
        if (type === "dbz") {
            typeKey = "radar"
        }
		rawPredictData[typeKey].forEach((el, index) => {
			if (type === '1hr' && ((index+1) % 6 === 0)) {
				html += `<option value="${index}">${el.predict_time.slice(0,4)}/${el.predict_time.slice(4,6)}/${el.predict_time.slice(6,8)} ${el.predict_time.slice(9,11)}:${el.predict_time.slice(11,13)}</option>`
			}
			if (type === '3hr' && index === (rawPredictData[typeKey].length-2)) {
				html += `<option value="${index}">${el.predict_time.slice(0,4)}/${el.predict_time.slice(4,6)}/${el.predict_time.slice(6,8)} ${el.predict_time.slice(9,11)}:${el.predict_time.slice(11,13)}</option>`
			}
			if (type === '10m' || type === 'dbz') {
				html += `<option value="${index}">${el.predict_time.slice(0,4)}/${el.predict_time.slice(4,6)}/${el.predict_time.slice(6,8)} ${el.predict_time.slice(9,11)}:${el.predict_time.slice(11,13)}</option>`
			}
		})
		$("#region-rain-prediction-time-selector").html(html)
		setTimeout(function(){
			$("#region-rain-prediction-time-selector").trigger('change')
		}, 500)
	}

    function villageAlertRender(option){
        let townContainer = {},
            alertLevelMapping = {
                "黃色": {
                    color: "yellow",
                    number: 0
                },
                "橘色": {
                    color: "orange",
                    number: 1
                },
                "紅色": {
                    color: "red",
                    number: 2
                }
            }
        rawPredictData.alert.forEach((el, index) => {
            let thisVillInfo = el.name.split("區"),
                thisTown = thisVillInfo[0] + "區",
                thisVillage = thisVillInfo[1]
            if (!townContainer[thisTown]) {
                townContainer[thisTown] = {
                    village: [],
                    level: "無",
                    layer: {
                        "紅色": "",
                        "橘色": "",
                        "黃色": ""
                    }
                }
            }
            townContainer[thisTown].village.push({
                name: thisVillage,
                level: el.level,
                villcode: el.villcode
            })
            // 行政區最大示警等級
            if (townContainer[thisTown].level === "無" || el.level === "紅色") {
                townContainer[thisTown].level = el.level
            } else if (townContainer[thisTown].level === "黃色" && (el.level !== "橘色" || el.level !== "紅色")) {
                townContainer[thisTown].level = el.level
            } else if (townContainer[thisTown].level === "橘色" && (el.level !== "紅色")) {
                townContainer[thisTown].level = el.level
            }
            // 村里geoserver字串組裝
            townContainer[thisTown]["layer"][el.level] += `'${el.villcode}',`
        })
		if (overlay_dataset["region_alert_target_town"]) {
			map.removeLayer(overlay_dataset["region_alert_target_town"])
		}
        if (Object.keys(townContainer).length > 0) {
			overlay_dataset["region_alert_target_town"] = L.geoJson(overlay_dataset["Basic_map"], {
                filter: function(feature){
                    return Object.keys(townContainer).includes(feature.properties["TOWNNAME"])
                },
				style: function(feature){
					return { 
                        fillColor: alertLevelMapping[townContainer[feature.properties["TOWNNAME"]].level].color, 
                        weight: 1, 
                        color: "white",
                        opacity: 1, 
                        fillOpacity: 0.4 
                    }
				},
				onEachFeature: function(feature, layer){
					layer.bindTooltip(feature.properties["TOWNNAME"] + "<br>達" + townContainer[feature.properties["TOWNNAME"]].level + "示警", {
						sticky: true,
						opacity: 1
					})
				}
			}).addTo(map)
            overlay_dataset["region_alert_target_town"].on("click", function(e){
                regionVillAlertAction(e.layer.feature.properties["TOWNNAME"])
            })
        }
        $("#region-rain-prediction-town-content").html(`
            <div class="card shadow-sm">
                <div class="card-body text-center">
                    ${option.timeString}<br>
                    降雨預報示警統計結果
                    <hr class="m-2">
                    <h5 class="font-weight-bold m-0 text-danger">共${Object.keys(townContainer).length}處行政區、${rawPredictData.alert.length}處村里</h5>
                </div>
            </div>
            <p class="text-muted mt-1">備註：點擊各行政區長條圖與地圖，檢視村里示警分布</p>
            <div id="region-rain-prediction-town-content-chart" class="h-380 mt-2"></div>
            <p class="text-justify text-muted">*燈號說明：預報期間內降雨，<i class="fas fa-circle mr-1" style="color: yellow;"></i>黃色：可能發生超過10mm/10分鐘，<i class="fas fa-circle mr-1" style="color: orange;"></i>橘色：可能發生超過40mm/1小時，<i class="fas fa-circle mr-1" style="color: red;"></i>紅色：可能發生超過10mm/10分鐘且超過40mm/1小時</p>
            <div id="region-rain-prediction-town-content-table"></div>`
        )

        // 
        let chartDataContainer = {
            "紅色": {}, "橘色": {}, "黃色": {}
        }
        Object.keys(townContainer).forEach(eachTown => {
            chartDataContainer["紅色"][eachTown] = { point: townContainer[eachTown].village.filter(el => { return el.level === "紅色" }).length }
            chartDataContainer["橘色"][eachTown] = { point1: townContainer[eachTown].village.filter(el => { return el.level === "橘色" }).length }
            chartDataContainer["黃色"][eachTown] = { point2: townContainer[eachTown].village.filter(el => { return el.level === "黃色" }).length }
        })
		stacked_chart({
			div: "region-rain-prediction-town-content-chart",
			data: [chartDataContainer["紅色"], chartDataContainer["橘色"], chartDataContainer["黃色"]],
			key_name: ["point", "point1", "point2"],
			label: ["紅色示警", "橘色示警", "黃色示警"],
			color: ["red", "orange", "yellow"],
			stackingType: "normal",
			yAxisLabel: "處",
			legend: true,
			title: "各行政區預測降雨示警村里長條圖",
			click_event_binding: function(trigger_input){
				let query_condition = trigger_input
                regionVillAlertAction(query_condition)
			}
		})

        regionTownAlertTable()
        function regionTownAlertTable(){
            let html = "",
                excelObject = {
                    sheetName: ["全區統計"],
                    sheetBody: [[["名稱", "示警總數", "紅色示警", "橘色示警", "黃色示警"]]]
                }
            Object.keys(chartDataContainer["紅色"]).forEach(eachTown => {
                let number = {
                    total: chartDataContainer["紅色"][eachTown].point + chartDataContainer["橘色"][eachTown].point1 + chartDataContainer["黃色"][eachTown].point2,
                    red: chartDataContainer["紅色"][eachTown].point,
                    orange: chartDataContainer["橘色"][eachTown].point1,
                    yellow: chartDataContainer["黃色"][eachTown].point2
                }
                excelObject.sheetBody[0].push([
                    eachTown, 
                    number.total + "處",
                    number.red + "處",
                    number.orange + "處",
                    number.yellow + "處"
                ])
                html += `
                    <tr townname="${eachTown}">
                        <td>${eachTown}</td>
                        <td>${number.total}處</td>
                        <td>${number.red}處</td>
                        <td>${number.orange}處</td>
                        <td>${number.yellow}處</td>
                    </tr>`
            })
            townVillTableHandle({
                html: `
                    <p class="text-center">
                        各行政區村里示警數量列表
                    </p>
                    <table class="table table-sm table-pointer table-hover text-center">
                        <thead class="thead-dark">
                            <tr>
                                <th>名稱</th>
                                <th>示警總數</th>
                                <th>紅色示警</th>
                                <th>橘色示警</th>
                                <th>黃色示警</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${html}
                        </tbody>
                    </table>`,
                table: {
                    "columnDefs": [
                        { type: 'formatted-num', targets: [1, 2, 3, 4] }
                    ],
                    "order": [[ 1, "desc" ]]
                },
                rowClick: function(dom){
                    let townname = dom.attr("townname")
                    regionVillAlertAction(townname)
                }
            })
            $("#region-rain-prediction-report-download").off().click(function(){
                if (html !== "") {
                    excelObject.sheetBody[0].forEach((eachRow, index) => {
                        if (index !== 0) {
                            let eachTown = eachRow[0],
                                eachTownList = []
                            townContainer[eachTown].village.forEach(each => {
                                eachTownList.push([each.name, each.level + "示警"])
                            })
                            excelObject.sheetName.push(eachTown)
                            excelObject.sheetBody.push([["名稱", "示警等級"]].concat(eachTownList))
                        }
                    })
                    downloadxlsx("降雨預測示警統計清單_" + option.timeString + ".xlsx", excelObject.sheetName, excelObject.sheetBody)
                } else {
                    toast_open("此預報統計結果無示警區域與村里！")
                }
            })
        }

        function regionVillAlertAction(query_condition){
            // 縮放至該行政區
            zoomToRegionMap(query_condition)
            // 
            let html = ""
            if (overlay_dataset["region_alert_target_town"]) {
                map.removeLayer(overlay_dataset["region_alert_target_town"])
            }
            Object.keys(townContainer[query_condition].layer).forEach(eachAlertLevel => {
                let thisCqlFilterString = townContainer[query_condition].layer[eachAlertLevel]
                if (thisCqlFilterString !== "") {
                    if (overlay_dataset["region_alert_target_village_" + eachAlertLevel]) {
                        map.removeLayer(overlay_dataset["region_alert_target_village_" + eachAlertLevel])
                    }
                    overlay_dataset["region_alert_target_village_" + eachAlertLevel] = L.WMS.overlay(publicPath + '/cloud/geoserver/taiwan/wms?',{
                        layers: 'taiwan:village_w84',
                        transparent: true,
                        format: 'image/png',
                        maxZoom: 22,
                        cql_filter: `COUNTYNAME = '新北市' and VILLCODE IN (${thisCqlFilterString.slice(0,thisCqlFilterString.length-1)})`,
                        styles: "taiwan:village_alert_" + alertLevelMapping[eachAlertLevel].color
                    }).addTo(map)
                }
            })
            townContainer[query_condition].village.forEach(each => {
                html += `
                    <tr villcode="${each.villcode}">
                        <td>${each.name}</td>
                        <td><span class="d-none">${alertLevelMapping[each.level].number}</span>${each.level}示警</td>
                    </tr>`
            })

            townVillTableHandle({
                html: `
                    <p class="text-center">
                        「${query_condition}」村里示警表單
                        <button type="button" class="btn btn-primary btn-sm ml-2 pt-0 pb-0">返回全區</button>
                    </p>
                    <table class="table table-sm table-pointer table-hover text-center">
                        <thead class="thead-dark">
                            <tr>
                                <th>名稱</th>
                                <th>示警等級</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${html}
                        </tbody>
                    </table>`,
                table: {
                    "order": [[ 1, "desc" ]]
                },
                rowClick: function(dom){
                    let villcode = dom.attr("villcode")
                    ajax_call_async(
                        publicPath + "/cloud/geoserver/taiwan/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=taiwan%3Avillage_w84&outputFormat=application%2Fjson&cql_filter=VILLCODE=%27" + villcode + "%27",
                        function(data){
                            map.fitBounds(L.geoJSON(data).getBounds())
                        }
                    )
                }
            })

            $("#region-rain-prediction-town-content-table button").click(function(){
                Object.keys(townContainer[query_condition].layer).forEach(eachAlertLevel => {
                    if (overlay_dataset["region_alert_target_village_" + eachAlertLevel]) {
                        map.removeLayer(overlay_dataset["region_alert_target_village_" + eachAlertLevel])
                    }
                })
                overlay_dataset["region_alert_target_town"].addTo(map)
                $("#home_view").click()
                regionTownAlertTable()
            })
        }

        function townVillTableHandle(option){
            $("#region-rain-prediction-town-content-table").html(option.html)
            $("#region-rain-prediction-town-content-table table").DataTable(option.table)
            $("#region-rain-prediction-town-content-table tbody").on("click", "tr", function(){
                option.rowClick($(this))
            })
        }
    }

	function regionAlertRender(){
		let option = {
				typeAccRain: $('#region-rain-prediction-type-selector').val()
			},
			iterObject = {
                '10m': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
				'1hr': [5, 11, 17],
				'3hr': [16]
			},
			result = {},
			regionAlertGeoJson = {},
			regionGeoJson = townData.features
		iterObject[option.typeAccRain].forEach(index => {
			let	rainRasterLayer = plotRainRasterGeoJson(index, option.typeAccRain),
				geoJsonFilter = turf.featureCollection([])
			result[String(index)] = {}
			regionAlertGeoJson[String(index)] = turf.featureCollection([])
			for (let eachRegionIndex in regionGeoJson) {
				for (let eachRainRasterIndex in geoJsonFilter.features) {
					if (result[String(index)][regionGeoJson[eachRegionIndex].properties['TOWNNAME']] === true) {
						break
					}
					var bool = turf.booleanPointInPolygon(turf.center(geoJsonFilter.features[eachRainRasterIndex]), regionGeoJson[eachRegionIndex])
					if (bool) {
						regionAlertGeoJson[String(index)].features.push(regionGeoJson[eachRegionIndex])
						result[String(index)][regionGeoJson[eachRegionIndex].properties['TOWNNAME']] = true
					}
				}
			}
		})
		return result, regionAlertGeoJson
	}

	function inputDisabledControl(bool){
		$('.region-rain-prediction-input').each(function(){
			$(this).attr('disabled', bool)
		})
	}

    function rainRasterStyle(feature){
        let color, 
            fillOpacity = 0.4;
        switch(true) {
            case (feature.properties.value <= 0):
                color = "#fff";
                fillOpacity = 0;
                break;
            case (feature.properties.value > 0 && feature.properties.value <= 1):
                color = "#c1c1c1";
                break;
            case (feature.properties.value > 1 && feature.properties.value <= 2):
                color = "#98ffff"
                break;
            case (feature.properties.value > 2 && feature.properties.value <= 6):
                color = "#00ceff"
                break;
            case (feature.properties.value > 6 && feature.properties.value <= 10):
                color = "#0198ff"
                break;
            case (feature.properties.value > 10 && feature.properties.value <= 15):
                color = "#0562ff"
                break;
            case (feature.properties.value > 15 && feature.properties.value <= 20):
                color = "#319904"
                break;
            case (feature.properties.value > 20 && feature.properties.value <= 30):
                color = "#36ff00"
                break;
            case (feature.properties.value > 30 && feature.properties.value <= 40):
                color = "#faff00"
                break;
            case (feature.properties.value > 40 && feature.properties.value <= 50):
                color = "#ffcc01"
                break;
            case (feature.properties.value > 50 && feature.properties.value <= 70):
                color = "#ff9703"
                break;
            case (feature.properties.value > 70 && feature.properties.value <= 90):
                color = "#f00800"
                break;
            case (feature.properties.value > 90 && feature.properties.value <= 110):
                color = "#cc0003"
                break;
            case (feature.properties.value > 110):
                color = "#a00000"
                break;
        }
        return {
            fillColor: color,
            weight: 0,
            opacity: 0,
            fillOpacity: fillOpacity
        };
    }
}
